module.exports = __webpack_public_path__ + "static/media/main_1.e8e4f9fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/Images/main_1.jpg
// module id = 890
// module chunks = 0